import { Playground } from "docz";
import "../../../../../scss/app.scss";
import * as React from 'react';
export default {
  Playground,
  React
};